import { create } from 'zustand';

export const useRewardStore = create((set) => ({
  filters: [],
  setFilters: (filters) => set({ filters }),
}));
